module.exports = __webpack_public_path__ + "linkedin-de68a7d36d56f3a0e56a.svg";